document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.njamito-hero-media__video[data-source-src]');

    videos.forEach(video => {
        function loadVideo(videoElement) {
            const source = document.createElement('source');
            source.src = videoElement.dataset.sourceSrc;
            source.type = videoElement.dataset.sourceType;
            videoElement.appendChild(source);
            videoElement.load();
            videoElement.play().catch(err => {
                console.log("Autoplay failed:", err);
            });
        }

        const style = window.getComputedStyle(video);
        if (style.display !== 'none' && video.querySelector('source') === null) {
            loadVideo(video);
        }

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.target.querySelector('source') === null) {
                    loadVideo(entry.target);
                    obs.unobserve(entry.target); // Stop observing after load
                }
            });
        }, {
            threshold: 0.1 // Trigger when at least 10% of the video is visible
        });

        observer.observe(video);
    });

    // YouTube hero backgrounds: drive via the IFrame API so we can autoplay
    // muted, loop seamlessly, and reveal the frame only once it is PLAYING —
    // which hides YouTube's centred play / prev / next chrome that shows while
    // the player is paused or loading.
    const ytFrames = Array.from(
        document.querySelectorAll<HTMLIFrameElement>('.njamito-hero-media__yt-player')
    );

    if (ytFrames.length) {
        const w = window as any;

        const initPlayers = () => {
            ytFrames.forEach(frame => {
                let loopTimer: number | undefined;

                const startSeamlessLoop = (player: any) => {
                    if (loopTimer) return;
                    // Poll and jump back BEFORE the clip ends — reaching the real
                    // end shows YouTube's replay/pause overlay for a beat.
                    loopTimer = window.setInterval(() => {
                        const duration = player.getDuration();
                        const current = player.getCurrentTime();
                        if (duration > 0 && duration - current < 0.4) {
                            player.seekTo(0, true);
                        }
                    }, 250);
                };

                new w.YT.Player(frame, {
                    events: {
                        onReady: (e: any) => {
                            e.target.mute();
                            e.target.playVideo();
                        },
                        onStateChange: (e: any) => {
                            if (e.data === w.YT.PlayerState.PLAYING) {
                                startSeamlessLoop(e.target);
                            }
                            // Safety net if the poll ever misses the window.
                            if (e.data === w.YT.PlayerState.ENDED) {
                                e.target.seekTo(0, true);
                                e.target.playVideo();
                            }
                        },
                    },
                });
            });
        };

        if (w.YT && w.YT.Player) {
            initPlayers();
        } else {
            const prev = w.onYouTubeIframeAPIReady;
            w.onYouTubeIframeAPIReady = () => {
                if (typeof prev === 'function') prev();
                initPlayers();
            };
            if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                document.head.appendChild(tag);
            }
        }
    }
});